import { FooterTypes } from '@dtx-company/true-common/src/types/footer'
import { prismicClient } from '@app/prismic/src/utils'

export const fetchFooterData = async (): Promise<Partial<FooterTypes>> => {
  return prismicClient
    .getSingle('footer', {})
    .then(({ data }) => data)
    .catch(e => {
      console.error('Error fetching footer data', e)
      return {}
    })
}
